import {Component} from '@angular/core';

@Component({
    selector: 'assignment-gap-choice-row',
    templateUrl: './assignment-gap-choice-row.component.html',
    styleUrls: ['./assignment-gap-choice-row.component.scss'],
})
export class AssignmentGapChoiceRowComponent {}
